import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { adminDashboardNames, finalCostModel, GenericmodalComponent, mapApiQuotationStatusToEnum, nonHostedFinalCostModel, NonhostedQuotationTableComponent, quotation_status, subscriptionPeriodModel } from 'ncache-common-library';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { QuotationService } from 'src/app/paid-subscription/services/quotation.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from 'src/app/common-layout/popup/popup.component';
import Helper from 'src/app/Util/helper';
import { POPUP_MESSAGES } from 'src/app/Util/constants';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import { CompleteUserDetails } from 'src/app/models/user.model';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule, Location } from '@angular/common';
import { QuotationPathEnum, QuotationStatus } from 'src/app/enums/quotation.enum';
import { UpdatedBy } from 'src/app/enums/environments.enum';
import { DateHelper } from 'src/app/Util/date-helper';


interface companyDateInterface {
  [key: string]: string;
}

@Component({
  selector: 'app-previewquotation',
  standalone: true,
  imports:[FontAwesomeModule,NonhostedQuotationTableComponent,RouterModule,CommonModule],
  templateUrl: './previewquotation.component.html',
  styleUrl: './previewquotation.component.css'
})
export class NonHostedPreviewquotationComponent {

  @ViewChild(GenericmodalComponent) genericModal!: GenericmodalComponent;
  quotationConfirmationRef: NgbModalRef;
  isPreview: boolean = true;
  isSupportQuotation: boolean = false;
  isQuotationModified: boolean = false;
  quotationCategoryName: string = '';
  subscriptionId: string = '';
  quotationId: string = '';
  cloudProvider: string = '';
  cloudPlan: string = '';
  userEmail: string = '';
  customerEmail: string = '';
  userDetails: CompleteUserDetails;
  alachisoftData = {
    name: 'Alachisoft',
    address: '5473 Blair Rd, Suite 100-99152, Dallas, Texas 75231, USA',
    phone: '+1 214-764-6933'
}

  CompanyTitle = 'Company ';
  contactTitle = 'Contact ';
  fromPath = ''
  salesPersonData = {};
  companyData: companyDateInterface = {};
  subscriptionData: subscriptionPeriodModel = new subscriptionPeriodModel();
  quotationStatus: string = ""
  subscriptionStatus: string = ""
  quotationType: string = "";
  is24x7QuotationEnabled: boolean = false;
  isLoadingData = false
  typeOfUser: any;
  planType: any;
  expiryData: any;
  fetchedQuotation: any = {};
  quotationTitle: string = "Quotation Details";
  successfulQuotationModal:any
  faCloud = faCloud
  previewData:any = []
  constructor(
    private route: Router,
    private quotationDetailsService: QuotationService,
    private readonly subscriptionSvc: CloudSubscriptionService,
    private activatedRoute: ActivatedRoute,
    private notificationService: CloudNotificationService,
    private readonly modal: NgbModal,
    private readonly environmentSvc: EnvironmentService,
    private readonly localStorageSvc:LocalStorageService,
    private cloudService: CloudProfileService,
    private location: Location
  ) 
  {}

  previewFinalCost: any;
  tyoeOfUser: adminDashboardNames = adminDashboardNames.Sales;

  ngOnInit(): void 
  {    
    this.getSubscriptionId()
    this.getUserData()
    this.subscribeToGlobalState()
    this.getParamsMap()
    this.isLoadingData = true
  
    this.activatedRoute.queryParams.subscribe((params) =>
      {
        this.quotationId= params['quotationId'];
        this.getQuotationByQuotationId()
        this.quotationType= params['quotationType'];
        this.quotationStatus = params['quotationStatus']
        this.subscriptionId = params['subscriptionId']
        this.subscriptionStatus = params['subscriptionStatus']
        this.cloudPlan = params['cloudPlan']
        this.typeOfUser = params['typeOfUser']
        this.planType = params['planType']
        this.isQuotationModified  = params['quotationModified'] == 'true' ? true :  false
        quotationGlobalState.populateIsQuotationModified( this.isQuotationModified)
      });

    if (this.quotationId != '' && this.quotationId != undefined)
    {
      quotationGlobalState.populateQuotationId(this.quotationId)
    }    
    else if (this.subscriptionId != '' && this.subscriptionId != undefined) 
    {
      this.getSubscriptionDetails(this.subscriptionId )
    }
  }

  private getParamsMap(): void {

    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.fromPath = params?.get('frompath') ?? undefined
    })

  }

  private getUserData() {
    this.cloudService.getCompleteUserDetails().subscribe({
      next: (res) => {
        this.userDetails = res;
      },
      error: (err) => {
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      },
    });
  }

  getCompanyDetails(){
  }

  subscribeToGlobalState()
  {
     
    quotationGlobalState.getAllIInvoice().subscribe((allEnvironments: any) => {
      this.previewData = allEnvironments;
    });
    quotationGlobalState.getNonHostedFinalCost().subscribe((env) => {
      this.previewFinalCost = env;

    if (this.previewFinalCost == null)
      {
        this.previewFinalCost = new nonHostedFinalCostModel()
      }
      
    });
    
    
    quotationGlobalState.geSubscriptionPeriod().subscribe((cat) => {
      this.subscriptionData = cat;
    });
    
    quotationGlobalState.getQuotationId().subscribe((env) => {      
      this.quotationId = env;
    });
    
    quotationGlobalState.getSubscriptionId().subscribe((env) => {
      this.subscriptionId = env;
    });
    
    quotationGlobalState.getQuotationCategory().subscribe((env) => {
      this.quotationCategoryName = env;
    });
    
    quotationGlobalState.getCloudProvider().subscribe((env) => {
      this.cloudProvider = env;
    });
    
    quotationGlobalState.getPlanEdition().subscribe((env) => {
      this.cloudPlan = env;
    });
    
    
  }

  private updateFinalCosts(res:any){

    let costs = {
      totalSoftwareCost:res?.totalSoftwareCost,
      totalInfratStructureCost:res?.totalInfraCost,
      _24X7Cost: res?.total24X7Price,
      totalDiscount:res?.discount ,
      totalCost:res?.totalCost ,
      absoluteCost: 0
    }
    this.previewFinalCost = costs
  }


  private getSubscriptionId(){
    this.subscriptionId = this.localStorageSvc.getItemSessionStorage(StorageKeys.SubscriptionId)
  }

  getSubscriptionDetails(subscriptionId : string)
  {

  this.subscriptionSvc.getSubscriptionDetail(this.subscriptionId).subscribe({
    next:(res)=>{
    },
    error:(err)=>{
      this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
    }
  })
  
  }


  cancel()
  {
    quotationGlobalState.resetQuotationGlobalState()
  }

  showExpryDate(){
    return DateHelper.convertToReadableDate(this.fetchedQuotation?.expiryDate)
  }



  private getQuotationByQuotationId(){
    this.quotationDetailsService.getNonHostedQuotationById(this.quotationId).subscribe({
      next:(res)=>{
        this.fetchedQuotation = res
       this.previewData = res?.lineItems
       this.updateFinalCosts(res)
      },
       error:(err)=>{
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)

       }
    })
  }

  openQuotationConfirmPopup() {
    this.quotationConfirmationRef = this.modal.open(PopupComponent)
    Helper.configurePopup(this.quotationConfirmationRef, {
      title: POPUP_MESSAGES.quotation_confirm_after_sales_approval.title,
      message: POPUP_MESSAGES.quotation_confirm_after_sales_approval.message,
      viewCancelBtn: true,
      viewCrossBtn: false,
      valueProcessor: (receivedConfirmation) => {
        if (receivedConfirmation) {
          this.quotationConfirmationRef.close();
          this.updateQuotationStatus()
        }
      }
    });
  }

  private updateQuotationStatus(){
    this.environmentSvc.updateQuotationStatus(this.quotationData()).subscribe({
      next:(res)=>{
        this.showQuotationSuccessful()
      },
      error:(err)=>{
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      }
    })
  }

  showQuotationSuccessful() {
    this.successfulQuotationModal = this.modal.open(PopupComponent,{
      backdrop: 'static',
      keyboard: false
    })
    Helper.configurePopup(this.successfulQuotationModal, {
      title: POPUP_MESSAGES.quotation_req_success_message.title,
      message: POPUP_MESSAGES.quotation_req_success_message.message,
      salesLink: POPUP_MESSAGES.quotation_req_success_message.salesLink,
      salesMessage:POPUP_MESSAGES.quotation_req_success_message.salesMessage,
      btnTitle: POPUP_MESSAGES.quotation_req_success_message.btnTitle,
      linkMessage: POPUP_MESSAGES.quotation_req_success_message.linkMessage,
      viewSalesMessage: true,
      viewCrossBtn: false,
      viewCancelBtn: false,
      viewLink: true,
      valueProcessor: (receivedConfirmation) => {
        if (receivedConfirmation) {
          this.successfulQuotationModal.close();
          this.navigateToDashBoard();
        }
      }
    });
  }

    private navigateToDashBoard(){
    this.route.navigate(['/subscription/dashboard'])
  }

  goToPreviousScreen(){
    this.location.back()
  }

  private quotationData()
  {
    let quotationData =
    {
      QuotationId: this.fetchedQuotation.quotationId,
      QuotationStatus: this.fetchedQuotation?.updatedBy === UpdatedBy.Sales ? QuotationStatus.Approve : QuotationStatus.Request ,
      UpdatedBy:UpdatedBy.Customer
    }
    return quotationData;
  }

  toggleButtons(){
    if(this.fromPath == QuotationPathEnum.TRANSACTION_LINK){
      return false
    }
    return true
  }

  getQuotationStatus(){
    return  (this.fetchedQuotation?.updatedBy == UpdatedBy.Customer && this.fetchedQuotation?.status == QuotationStatus.Approve) || (this.fetchedQuotation?.updatedBy == UpdatedBy.Accounts && this.fetchedQuotation?.status == QuotationStatus.Active) || (this.fetchedQuotation?.status == QuotationStatus.Reject)
  }

  togglePreviousButton(){
    return this.fromPath == QuotationPathEnum.EMAIL_LINK
  }



}
